import { memo } from "react";
import { TableToolbar, TableToolbarProps } from "ui/widgets/Table";
import { selectIsExportUsersLoading } from "features/users/selectors";
import Button from "@mui/material/Button";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { useResourceContext } from "ui/widgets/Resource";
import Box from "@mui/material/Box";
import BulkCreateUsers from "./BulkCreateUsers";

const Add = () => {
    const { onOpen } = useResourceContext();

    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
            size='small'
            startIcon={<GroupAddIcon />}
            onClick={() => onOpen()}
        >
            Add User
        </Button>
            <BulkCreateUsers />
        </Box>
    );
};

const UserToolbar = ({ onExport }: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        onExport={onExport}
        selectIsExportLoading={selectIsExportUsersLoading}
        add={Add}
    />
);

export default memo(UserToolbar);
